import React from "react";

const FormButtonStyle3 = ({
  text = "Get OTP",
  onClick,
  disabled = false,
  className = "",
  id = "",
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={className}
      id={id}
      style={{
        width: "340px",
        padding: "14px 0",
        fontSize: "16px",
        fontWeight: 400,
        color: "#12F280",
        background: disabled
          ? "#333"
          : "black",
        border: "none",
        borderRadius: "5px",
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        fontFamily: "Atkinson Hyperlegible",
        marginLeft: "auto",
        marginRight: "auto", 
      }}
    >
      {text}
      <img
        src="/assets/img/CTA Arrow black.svg"
        alt="arrow"
        style={{
          width: "18px",
          height: "18px",
          objectFit: "contain",
        }}
      />
    </button>
  );
};

export default FormButtonStyle3;
